import React from "react";

interface IProps {
  resetForm: () => void; 
  submitForm: () => void; 
}

const CpntFilterButtons: React.FC<IProps> = ({ resetForm, submitForm }) => {
  return (
    <div className="row mt-4 mb-2">
      {/* Bouton Réinitialiser */}
      <div className="offset-0 col-12 offset-md-0 col-md-6 offset-lg-4 col-lg-4 p-1">
        <button
          className="col btn btn-darkgrey grandBoutton w-100"
          type="reset"
          onClick={resetForm}
        >
          Réinitialiser
        </button>
      </div>

      {/* Bouton Rechercher */}
      <div className="offset-0 col-12 offset-md-0 col-md-6 offset-lg-0 col-lg-4 p-1">
        <button
          id="submit-btn"
          className="col btn btn-secondary grandBoutton w-100"
          type="button" // On garde "button" ici
          onClick={submitForm}
        >
          Rechercher
        </button>
      </div>
    </div>
  );
};

export default CpntFilterButtons;